import type { AvailableISO639ForTranslation, TranslationKey } from '@partful/shared-types';
import { useTenant } from 'src/providers/Tenant';

export default function useTranslation(itemToTranslate: TranslationKey, defaultTranslation: string) {
  const { translations } = useTenant();
  const locale: AvailableISO639ForTranslation = 'en-gb'; // in the future we should add locale to the user
  return translations?.[locale]?.[itemToTranslate] ?? defaultTranslation;
}
